import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import ChainedBackend from "i18next-chained-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import LocalStorageBackend from "i18next-localstorage-backend";
import Backend from "i18next-http-backend";

import { getEnvVar } from "@/config";

const translationApiUrl = getEnvVar("appTranslationApiUrl");

const IS_DEV = import.meta.env.VITE_REACT_APP_ENV === "dev";
// 10 minutes
const timeToLiveDev = 10 * 60 * 1000;

// 30 minutes
const timeToLiveProd = 30 * 60 * 1000;

const timeToLive = IS_DEV ? timeToLiveDev : timeToLiveProd;

const translationToken = getEnvVar("appTranslationSystemToken");

if (!translationToken) {
	throw new Error("Missing translation system token");
}

if (!translationApiUrl) {
	throw new Error("Missing translation system URL");
}

const storedLang = localStorage.getItem("i18nextLng");
if (storedLang) {
	localStorage.removeItem("i18nextLng");
}

i18n
	.use(ChainedBackend)
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		debug: IS_DEV,
		lng: "en",
		fallbackLng: "en",
		returnEmptyString: false,
		returnNull: false,
		detection: {
			caches: ["sessionStorage"],
		},
		backend: {
			backends: [LocalStorageBackend, Backend],
			backendOptions: [
				{
					expirationTime: timeToLive,
				},
				{
					loadPath: `${translationApiUrl}/api/translations/sales-and-delivery/{{ns}}/{{lng}}/file/`,
					requestOptions: {
						cache: "no-store",
					},
					customHeaders: {
						Authorization: `Token ${translationToken}`,
					},
					expirationTime: timeToLive,
				},
			],
		},
	});

export default i18n;
